import { GenericService } from '@/services/api/generic.service';
import { Organisation } from '@/models';
import { AxiosRequestConfig } from 'axios';

export class DomainOrganisationService extends GenericService<Organisation> {

  constructor(domainId: string) {
    super(`v1/domains/${domainId}/organisations`);
  }

  async getOrganisationsWithHierarchy(params?: AxiosRequestConfig): Promise<Organisation[]> {
    try {
      const response = await this.index({
        ...params,
        params: {
          ...params?.params,
          include: 'domain,orderConfiguration'
        }
      });

      if (response === null) {
        return null;
      }

      const organisations = 'data' in response ? response.data : response as Organisation[];
      return organisations;
    } catch (error: any) {
      if (error.response?.status === 403) {
        throw new Error('Access denied to organisation details');
      } else if (error.response?.status === 404) {
        throw new Error('Domain not found');
      }
      throw error;
    }
  }
}
